export enum StatusEnum {
  Approved = "approved",
  Rejected = "rejected",
  Pending = "pending",
}
